@import "/src/variables/font_size";
@import "/src/variables/color";
@import "/src/variables/font";
@import "/src/variables/tokens";

.main {
    padding: $space-8 $space-12 $space-8 $space-12;
    background-color: $Brand-Primary-Light;
    text-align: center;
    .promoDesc {
        font-style: Medium;
        font-size: $font-size-xs-tiny;
        line-height: $line-height-140-heading;
        letter-spacing: 0%;
        color: $Brand-Primary;
    }
}